import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import SimpleHeader from './SimpleHeader';
import MobileAppBar from './MobileAppBar';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  // Extract language from pathname (e.g., /de/player/123 -> 'de')
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const langFromPath = pathSegments[0];
  const currentLang = (['en', 'fr', 'de', 'it'].includes(langFromPath)
    ? langFromPath
    : 'en') as 'en' | 'fr' | 'de' | 'it';

  const isHomePage = location.pathname === '/' ||
                      location.pathname === '/en' ||
                      location.pathname === '/fr' ||
                      location.pathname === '/de' ||
                      location.pathname === '/it';

  // Hide app bar on codes page
  const isCodesPage = location.pathname.includes('/codes');

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <SimpleHeader isHomePage={isHomePage} />
      <main className="pt-16">
        {children}
      </main>
      {!isCodesPage && <MobileAppBar lang={currentLang} />}
    </div>
  );
};

export default Layout;